import React, { createContext, useState, useEffect, useContext } from 'react';

const UserContext = createContext();

const UserProvider = ({ children }) => {
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [user, setUser] = useState(null);

	//user stores the logged-in user's information
	useEffect(() => {
		const storedLoginStatus = localStorage.getItem('isLoggedIn');
		const storedUser = localStorage.getItem('user');

		if (storedLoginStatus === 'true' && storedUser) {
			try {
				setIsLoggedIn(true);
				setUser(JSON.parse(storedUser)); //Loads the data saved earlier in the browser
			} catch (error) {
				console.error('Error parsing user data:', error);
				localStorage.removeItem('isLoggedIn');
				localStorage.removeItem('user');
			}
		}
	}, []);

	const login = (userData) => {
		try {
			localStorage.setItem('isLoggedIn', 'true');
			localStorage.setItem('user', JSON.stringify(userData));
			setIsLoggedIn(true);
			setUser(userData);
		} catch (error) {
			console.error('Error saving user data:', error);
		}
	};

	const logout = () => {
		try {
			localStorage.removeItem('isLoggedIn');
			localStorage.removeItem('user');
			setIsLoggedIn(false);
			setUser(null);
		} catch (error) {
			console.error('Error removing user data:', error);
		}
	};

	return <UserContext.Provider value={{ isLoggedIn, user, login, logout }}>{children}</UserContext.Provider>;
};

const useUser = () => {
	const context = useContext(UserContext);
	if (!context) {
		throw new Error('useUser must be used within a UserProvider');
	}
	return context;
};

export { UserContext, UserProvider, useUser };
